module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toast-container",
    attrs: {
      "aria-live": "polite",
      "aria-atomic": "true"
    }
  }, [_c('TransitionGroup', {
    attrs: {
      "name": "toast",
      "tag": "div",
      "appear": ""
    }
  }, _vm._l((_vm.messages), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "toast show",
      attrs: {
        "role": "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
      },
      on: {
        "mouseover": function($event) {
          return _vm.pauseProgress(item)
        },
        "mouseout": function($event) {
          return _vm.resumeProgress(item)
        }
      }
    }, [(item.timeOut > 0 && item.showProgress) ? _c('div', {
      staticClass: "progress rounded-0",
      staticStyle: {
        "height": "6px"
      }
    }, [_c('div', {
      class: 'bg-' + item.type,
      style: ({
        width: _vm.getCurrentProgress(item) + '%'
      })
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "toast-header",
      class: 'bg-' + item.type,
      staticStyle: {
        "height": "35px"
      }
    }, [_c('strong', {
      staticClass: "ml-auto"
    }, [_c('i', {
      staticClass: "toast-icon",
      class: _vm.getIconClass(item)
    })]), _vm._v(" "), (item.closeable) ? _c('button', {
      staticClass: "mr-2 mb-1 close",
      attrs: {
        "type": "button",
        "data-dismiss": "toast",
        "aria-label": "Close"
      },
      on: {
        "click": function($event) {
          return _vm.remove(item)
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "toast-body"
    }, [_vm._v(_vm._s(item.message))])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-768c0709","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bootstrap-toasts/src/components/Toasts.vue
// module id = 713
// module chunks = 1